import React, { useContext } from 'react'
import styled from 'styled-components'

import media from 'media'

import { SectionContext, TYPE_SECTION } from 'components/page/Section'

import Carousel from '@anvilco-pkg/ui/components/Carousel'

import { PADDING_X, MOBILE_PADDING } from 'components/page/Section/constants'

import { getThemeLength, calculateLength } from 'helpers'

// TODO: v important! send section type down via React context - consumers wont have to pass
// section type, these components will just know based on context.
const StyledCarousel = styled(Carousel).withConfig({
  shouldForwardProp: (prop) => ['sectionType'].indexOf(prop) === -1,
})`
  width: 100vw;
  margin-left: ${({ theme, sectionType }) => {
    const mobilePadding = getThemeLength({
      theme,
      key: 'padding',
      component: sectionType || TYPE_SECTION,
      breakpoint: 'mobile',
    })

    return calculateLength(mobilePadding?.left || MOBILE_PADDING, '*', -1)
  }};

  .slick-arrow {
    z-index: 50;
  }

  .slick-slide:not(.slick-active) .carousel-asset {
    display: none;
  }

  ${media.desktop`
    margin-left: ${({ theme, sectionType }) => {
      const desktopPadding = getThemeLength({
        theme,
        key: 'padding',
        component: sectionType || TYPE_SECTION,
        breakpoint: 'desktop',
      })

      return calculateLength(desktopPadding?.left || PADDING_X, '*', -1)
    }};
  `}

  ${media.giant`
    margin-left: ${({ theme, sectionType }) => {
      const padding = getThemeLength({
        theme,
        key: 'padding',
        component: sectionType || TYPE_SECTION,
      })

      return calculateLength(padding?.left || PADDING_X, '*', -1)
    }};
  `}

  @media (min-width: 1266px) {
    width: 1266px;
  }
`

export default function FullWidthCarousel ({ children, ...others }) {
  const { type: sectionType } = useContext(SectionContext)
  return (
    <StyledCarousel sectionType={sectionType} {...others}>
      {children}
    </StyledCarousel>
  )
}
